 import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from "./ui/table";
import { useState, useEffect } from "react";
import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useNavigate, useLocation } from "react-router-dom";
import { useNotification } from '../context/NotificationContext';

export default function LeadsTable() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedCityLeads, setSelectedCityLeads] = useState([]);
  const [chosenRepId, setChosenRepId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const [action, setAction] = useState(null); // "upload" | "discount" | "unlock"
  const [file, setFile] = useState(null);
  // const [categories, setCategories] = useState(["Category A", "Category B", "Category C"]); // example categories
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [discountValue, setDiscountValue] = useState("");
  const [unlockedLocation, setUnlockedLocation] = useState(null);
  // Inside your LeadsTable component, at the top with other state hooks
const [categoryDiscounts, setCategoryDiscounts] = useState({});   // discounts per category
const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);
const [vendorCategories, setVendorCategories] = useState([]);
const { notifications, setNotifications } = useNotification();
console.log("notifications:", notifications);
const [filters, setFilters] = useState({
    city: "",
    performanceStatus: "",
  });
  const [selectedFilterCategory, setSelectedFilterCategory] = useState("city");
  const [leadsData, setLeadsData] = useState([]);
  const isSalesRepPage = location.pathname.includes("/mfr/app/salesrep");

  const statusColorMap = {
    Excellent: "bg-gradient-to-r from-emerald-500 to-green-400 text-white shadow-sm",
    Good: "bg-gradient-to-r from-blue-500 to-sky-400 text-white shadow-sm",
    Average: "bg-gradient-to-r from-amber-500 to-yellow-400 text-white shadow-sm",
    Poor: "bg-gradient-to-r from-rose-500 to-red-400 text-white shadow-sm",
  };

// Get latest notification projectCodes
const highlightedLeadIds = notifications
  .filter(n => n.data?.projectCode)   // make sure projectCode exists
  .map(n => n.data.projectCode);


console.log("highlightedLeadIds:", highlightedLeadIds);
  useEffect(() => {
    fetchManufacturerLeads();   
    fetchCategories();
    fetchVendorCategories();
  }, []);


  function openEditModal(rep) {
    setSelectedLead(rep);
    const repsInCity = leadsData.filter(r => r.city === rep.city);
    setSelectedCityLeads(repsInCity);
    setChosenRepId(rep.id);
  }

  function closeModal() {
    setSelectedLead(null);
    setSelectedCityLeads([]);
    setChosenRepId(null);
    setUnlockedLocation(null);
    setAction(null);

  }

 const handleNavigate = () => {
  navigate("/mfr/app/leads");
};

  const handleClearAll = () => {
    setFilters({ city: "", performanceStatus: "" });
    setSearchQuery("");
  };

  function openEditModal(rep) {
  setSelectedLead({ ...rep }); // clone to avoid direct mutation
  setChosenRepId(rep.id);
}


  const filteredData = leadsData?.filter((rep) => {
    const matchesSearch = Object.values(rep)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    const matchesCity = filters.city ? rep.city === filters.city : true;
    const matchesPerformance = filters.performanceStatus
      ? rep.performanceStatus === filters.performanceStatus
      : true;

    return matchesSearch && matchesCity && matchesPerformance;
  });

  const chosenRep = selectedCityLeads.find(r => r.id === chosenRepId);
  const activeFilters = Object.entries(filters).filter(([_, value]) => value);




const fetchManufacturerLeads = async (period = "year") => {
  try {
    //const userData = JSON.parse(sessionStorage.getItem("userData"));
        const manufacturerId = sessionStorage.getItem('userId');   

    //const token = userData?.token;

    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const apiUrl = `${fetchUrl}manufacturer/get-manufacturer-leads?manufacturerId=${manufacturerId}&period=${period}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
       // "x-token": token, // 👈 backend will use this if verifyToken is enabled
      },
    });

    const data = await response.json();
    console.log("Manufacturer Leads Data by project:", data);

    if (response.ok && data) {
      // 👇 update state with entire object since backend returns { totalProjects, totalFlats, leadsByType, projectWiseData }
      setLeadsData(data.projectWiseData);  
    } else {
      console.error("Failed to fetch leads:", data.message);
    }
  } catch (error) {
    console.error("Error in fetchManufacturerLeads:", error);
  }
};



const handleSendDiscount = async (categoryDiscounts) => {
  try {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const vendorId = userData?.userId;

    // Loop through selected categories and send each discount as a separate request
    for (const [categoryId, discount] of Object.entries(categoryDiscounts)) {
      // Create payload exactly as backend expects
      const payload = {
        customerId: selectedLead.customerId,
        projectId: selectedLead.projectId,
        categoryId,
        vendorId,
        discount,
      };

      console.log("Sending discount payload:", payload);

      const response = await fetch(
        process.env.REACT_APP_FORE_BRICKBUCKET + "customer/rfq/update-quote-discount",
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload), // <-- flat object, not wrapped in array
        }
      );

      const data = await response.json();
      console.log("Discount update response:", data);

      if (response.ok && data.success) {
        console.log("Discount updated:", data);
      } else {
        console.error("Failed to update discount:", data.message);
      }
    }

    // Reset state after sending
    setAction(null);
    setSelectedCategories([]);
    setCategoryDiscounts({});
    setDiscountValue("");

  } catch (error) {
    console.error("Error sending discount:", error);
  }
};




// Unlock location
const handleUnlockLocation = async (projectId) => {
  try { 
    //const token = userData?.token;

    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const apiUrl = `${fetchUrl}manufacturer/get-project-location-link?projectId=${projectId}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
       // "x-token": token, 
      },
    });

    const data = await response.json();
    console.log(" project loction:", data);

    if (response.ok && data) {
    setUnlockedLocation(data);
    } else {
      console.error("Failed to fetch location link:", data.message);
      setUnlockedLocation(data.error);
    }
  } catch (error) {
    console.error("Error unlocking location:", error);
  }
};


const handleSendQuotation = async () => {
  if (!file || file.length === 0) {
    return alert("Please select at least one file");
  }

  try {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    console.log("userData:", userData);
 const vendorCategories = await fetchVendorCategories();
/* if (!vendorCategories || vendorCategories.length === 0) {
  return alert("No assigned categories found for this vendor");
} */

  console.log("vendorCategories:", vendorCategories);

const assignedCategoryId = vendorCategories[0]._id; // sa

    const formData = new FormData();
    // Required identifiers from backend
    formData.append("customerId", selectedLead.customerId); 
    formData.append("projectId", selectedLead.projectId);    
    formData.append("categoryId",  assignedCategoryId); 
    formData.append("vendorId", userData?.userId); 
    // Append all selected files
   for (let i = 0; i < file.length; i++) {
  formData.append("files", file[i]); // now file[i] is valid
}


    
    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const apiUrl = `${fetchUrl}customer/rfq/upload-project-quote`;

    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData, // fetch sets Content-Type automatically for FormData
    });

    console.log('body',formData);
    const data = await response.json();
    console.log("Upload quotation response:", data);

    if (response.ok && data.success) {
      alert("Files uploaded successfully");
      closeModal();
    } else {
      alert("Upload failed: " + data.message);
    }
  } catch (error) {
    console.error("Error uploading quotation:", error);
    alert("Error uploading quotation");
  }
};

const fetchCategories = async () => {
  try {
    setLoading(true);
    const response = await fetch(
      fetchUrl + "product-category/get-all-productCategories?is_ecommerce=true",
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    const data = await response.json();
    console.log("Fetched categories:", data);

    if (data.success) {
      setCategories(data.data);
      return data.data;  // ✅ return categories list
    } else {
      console.error("Failed to fetch categories:", data.message);
      setError("Failed to fetch categories");
      return [];  // ✅ return empty array on failure
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    setError("Error fetching categories");
    return [];  // ✅ return empty array on error
  } finally {
    setTimeout(() => setLoading(false), 2000);
  }
};


// Example: Fetch product categories assigned to the logged-in vendor
const fetchVendorCategories = async () => {
  try {
    // Get user data from sessionStorage
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const vendorId = userData?.userId;

    if (!vendorId) {
      console.error("Vendor ID not found in sessionStorage");
      return;
    }

    const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
    const apiUrl = `${fetchUrl}product-category/get-productCategoriesBy-vendor_id?vendor_id=${vendorId}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-token": userData?.token, // if your backend requires token verification
      },
    });

    const data = await response.json();
    console.log("Vendor assigned categories:", data);


    if (response.ok && data.success) {
      // Do something with categories
     setVendorCategories(data.data); // array of product categories
    } else {
      console.error("Failed to fetch categories:", data.message);
    }

        return data.data; // return categories for further use

  } catch (error) {
    console.error("Error fetching vendor categories:", error);
  }
};

return (
  <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white px-4 pb-3 pt-4   sm:px-6">

    {/* Header - better mobile layout */}
    <div className="flex flex-col gap-3 mb-4">

      {/* Leads heading - always at top */}
      <div className="text-lg font-semibold text-[#000000] ">
        Leads
      </div>

      {/* Search bar full-width on mobile */}
      <input
        type="text"
        placeholder="Search..."
        className="w-full border px-3 py-2 text-sm rounded-lg border border-gray-300 text-gray-400"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {/* Button row below search on mobile */}
   <div className="flex flex-wrap gap-2 sm:flex-nowrap sm:items-center justify-end w-full">
  <button
    onClick={() => setShowFilterModal(true)}
    className="inline-flex items-center justify-center gap-1 border border-gray-300 bg-white px-2 py-1 text-xs font-medium rounded-lg text-[#000000] border border-gray-300 "
  >
    Filter
  </button>

  {!isSalesRepPage && (
    <button
      onClick={handleNavigate}
      className="inline-flex items-center justify-center gap-1 border border-gray-300 bg-white px-2 py-1 text-xs font-medium rounded-lg text-[#000000] border border-gray-300"
    >
      See all
    </button>
  )}
</div>

    </div>

    {/* Filters and Search Chips */}
    {(activeFilters.length > 0 || searchQuery) && (
      <div className="mb-3">
        <div className="flex items-center gap-2 overflow-x-auto whitespace-nowrap sm:flex-wrap sm:overflow-visible py-1">
          {searchQuery && (
            <span className="shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-xs">
              Search: {searchQuery}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer"
                onClick={() => setSearchQuery("")}
              />
            </span>
          )}

          {activeFilters.map(([key, value]) => (
            <span
              key={key}
              className="shrink-0 inline-flex items-center gap-1 px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs"
            >
              {key}: {value}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer"
                onClick={() => setFilters((f) => ({ ...f, [key]: "" }))}
              />
            </span>
          ))}

          <button
            onClick={handleClearAll}
            className="shrink-0 text-xs px-3 py-1 bg-red-100 text-red-700 rounded-full hover:bg-red-200"
          >
            Clear All
          </button>

          <span className="ml-auto hidden sm:inline text-xs text-gray-500">
            {filteredData.length} results
          </span>
        </div>

        <div className="sm:hidden mt-1 text-right text-xs text-gray-500">
          {filteredData.length} results
        </div>
      </div>
    )}

    {/* DESKTOP TABLE (unchanged) */}
 <div className="hidden md:block max-w-full overflow-x-auto">
  <div className="max-w-full overflow-x-auto">
    <Table className="border border-gray-300 bg-white">
      <TableHeader className="border-b border-gray-300 bg-white">
        <TableRow>
          {["Lead", "City", "Call Initiated", "RFQ Response Speed (hrs)", "Status", "Actions"].map(
            (header) => (
              <TableCell
                key={header}
                isHeader
                className="py-3 px-2 font-medium text-[#000000] text-center text-xs uppercase tracking-wide"
              >
                {header}
              </TableCell>
            )
          )}
        </TableRow>
      </TableHeader>

      <TableBody className="divide-y divide-gray-300 bg-white">
        {filteredData.map((rep) => (
          <TableRow
            key={rep.id}
            className={`hover:bg-gray-100 transition-colors duration-200 ${
    highlightedLeadIds.includes(rep.leadId) ? "bg-red-100 animate-pulse" : ""
  }`}
          >
       <TableCell className="py-3 px-2 text-[#000000] font-medium">
  <div className="flex items-center ml-8 gap-2">
    {/* Lead ID */}
    <span>{rep.leadId}</span>

    {/* Units as Badge */}
    <span className="px-2 py-0.5 rounded-full bg-gray-100 text-[#000000] text-xs font-semibold">
      {rep.unitsCount} Units
    </span>
  </div>
</TableCell>

            <TableCell className="py-3 px-2 text-[#000000]">{rep.city}</TableCell>
            <TableCell className="py-3 px-2 text-center text-[#000000]">{rep?.callInitiated}</TableCell>
            <TableCell className="py-3 px-2 text-center text-[#000000]">{rep?.rfqResponseSpeedHrs}</TableCell>
            <TableCell className="py-3 px-2 text-center">
              <span
                className={`px-3 py-1.5 text-xs font-semibold rounded-full ${
                  statusColorMap[rep.status] || "bg-gray-300 text-[#000000]"
                }`}
              >
                {rep.status}
              </span>
            </TableCell>
            <TableCell className="py-3 px-2 text-center">
              <button
                onClick={() => openEditModal(rep)}
                className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition"
                title="Edit"
              >
                <PencilIcon className="h-5 w-5 text-[#000000]" />
              </button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
</div>


    {/* MOBILE CARD LIST - Improved spacing + layout */}
    {/* Horizontal Scroll Container */}
{/* Horizontal Scroll Cards for Leads (Styled like your SalesRep cards with icons/colors) */}
<div className="md:hidden overflow-x-auto flex space-x-3 pb-3
  [&::-webkit-scrollbar]:hidden [-ms-overflow-style:'none'] [scrollbar-width:'none']">
  {filteredData.map((rep) => (
    <div
      key={rep.id}
      className={`relative min-w-[230px] max-w-[230px] flex-shrink-0 rounded-xl shadow-sm border p-3
    ${highlightedLeadIds.includes(rep.leadId) ? "border-red-500 animate-pulse" : "border-gray-200"}`}
    >
      {/* Row 1: LeadId + Status */}
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-800  truncate">
          {rep.leadId}
        </h3>
        <span
          className={`px-2 py-0.5 rounded-full text-[10px] font-medium 
            ${statusColorMap[rep.status] || "bg-red-100 text-gray-800"}`}
        >
          {rep.status}
        </span>
      </div>

      {/* Row 2: Image + Units */}
      <div className="flex items-center justify-between mb-3">
        {/* Lead Image or Fallback */}
        {rep?.image ? (
          <img
            src={process.env.REACT_APP_FORE_MEASURIT_UIIMAGEURL + rep.image}
            alt={rep.leadId}
            className="w-8 h-8 rounded-md object-cover bg-gray-100"
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = ""; // fallback
            }}
          />
        ) : (
          <div className="w-8 h-8 rounded-md flex items-center justify-center bg-gray-100">
            <span className="text-[9px] text-gray-400 leading-tight text-center">
              No<br />Img
            </span>
          </div>
        )}

        <div className="inline-flex px-2 py-0.5 rounded-full bg-violet-100 text-[#000000] text-[11px] font-semibold">
          {rep.unitsCount} Units
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid grid-cols-2 gap-x-3 gap-y-1 text-[11px] leading-4">
        <p className="text-gray-500 ">📍 {rep.city}</p>
        <p className="text-gray-600 ">📩 RFQ hrs:
          <span className="ml-1 font-medium">{rep?.rfqResponseSpeedHrs || "0.0"}</span>
        </p>
        <p className="text-gray-600 ">📊 Calls: 
          <span className="ml-1 font-medium">{rep?.callInitiated}</span>
        </p>
      </div>

      {/* Action Button */}
      <div className="mt-2 text-right">
        <button
          onClick={() => openEditModal(rep)}
          className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md 
                     bg-blue-50 text-blue-600 hover:bg-blue-100  
                     text-[11px] font-medium transition"
        >
          <PencilIcon className="h-3 w-3" />
          Actions
        </button>
      </div>
    </div>
  ))}
</div>




    {/* MODALS BELOW — NO UI CHANGES NEEDED UNLESS REQUESTED */}
     {showFilterModal && (
      <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
        <div className="bg-white/90  p-6 rounded-2xl shadow-2xl w-full max-w-lg border border-gray-200  relative flex">
          <XMarkIcon
            className="w-6 h-6 absolute top-4 right-4 cursor-pointer text-gray-500 hover:text-gray-700"
            onClick={() => setShowFilterModal(false)}
          />

          <div className="w-1/3 border-r  pr-4">
            <h2 className="text-lg font-semibold mb-4 text-gray-800 ">
              Filter By
            </h2>
            <ul className="space-y-2">
              <li
                className={`cursor-pointer px-3 py-2 rounded-lg transition ${
                  selectedFilterCategory === "city"
                    ? "bg-blue-100 text-blue-700"
                    : "hover:bg-gray-100 "
                }`}
                onClick={() => setSelectedFilterCategory("city")}
              >
                City
              </li>
            </ul>
          </div>

          <div className="w-2/3 pl-4 animate-fadeIn">
            <h3 className="text-md font-semibold mb-4 text-gray-700 ">
              {selectedFilterCategory === "city" ? "Select City" : "Select Performance"}
            </h3>
            <ul className="space-y-2">
              <li
                className={`cursor-pointer px-3 py-2 rounded-lg ${
                  !filters[selectedFilterCategory]
                    ? "bg-blue-500 text-white"
                    : "hover:bg-gray-100 "
                }`}
                onClick={() => {
                  setFilters((f) => ({ ...f, [selectedFilterCategory]: "" }));
                  setShowFilterModal(false);
                }}
              >
                All
              </li>
              {selectedFilterCategory === "city"
                ? [...new Set(leadsData.map((r) => r.city))].map((city) => (
                    <li
                      key={city}
                      className={`cursor-pointer px-3 py-2 rounded-lg ${
                        filters.city === city
                          ? "bg-blue-500 text-white"
                          : "hover:bg-gray-100 "
                      }`}
                      onClick={() => {
                        setFilters((f) => ({ ...f, city }));
                        setShowFilterModal(false);
                      }}
                    >
                      {city}
                    </li>
                  ))
                : [...new Set(leadsData.map((r) => r.performanceStatus))].map((status) => (
                    <li
                      key={status}
                      className={`cursor-pointer px-3 py-2 rounded-lg ${
                        filters.performanceStatus === status
                          ? "bg-blue-500 text-white"
                          : "hover:bg-gray-100 "
                      }`}
                      onClick={() => {
                        setFilters((f) => ({ ...f, performanceStatus: status }));
                        setShowFilterModal(false);
                      }}
                    >
                      {status}
                    </li>
                  ))}
            </ul>
          </div>
        </div>
      </div>
    )}

    {/* Action Modal (unchanged) */}
    {selectedLead && (
      <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50">
        <div className="bg-white/95  p-6 rounded-2xl shadow-2xl w-full max-w-md border border-gray-200  relative">
          <XMarkIcon
            className="w-6 h-6 absolute top-4 right-4 cursor-pointer text-gray-500 hover:text-gray-700 transition"
            onClick={closeModal}
          />

          <h2 className="text-lg font-semibold mb-4 text-gray-800 ">
            Actions for Lead: {selectedLead.leadId}
          </h2>

          <div className="flex flex-col gap-3 mb-4">
            <button
              onClick={() => setAction("upload")}
              className={`w-full px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100 transition ${
                action === "upload" ? "border-blue-500 bg-blue-50" : "border-gray-300"
              }`}
            >
              Upload Quotation
            </button>
            <button
              onClick={() => setAction("discount")}
              className={`w-full px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100 transition ${
                action === "discount" ? "border-blue-500 bg-blue-50" : "border-gray-300"
              }`}
            >
              Give Discount
            </button>
            <button
              onClick={() => {
                setAction("unlock");
                handleUnlockLocation(selectedLead.leadId);
              }}
              className={`w-full px-4 py-2 border rounded-lg text-gray-700 hover:bg-gray-100 transition ${
                action === "unlock" ? "border-blue-500 bg-blue-50" : "border-gray-300"
              }`}
            >
              Unlock Location
            </button>
          </div>

          {action === "upload" && (
            <div className="mt-4">
              <label className="block mb-2 text-sm font-medium text-gray-700 ">
                Select File
              </label>
              <input
                type="file"
 onChange={(e) => setFile(Array.from(e.target.files))}      
            className="mb-4 w-full border rounded-lg p-2 "
              />
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setAction(null)}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSendQuotation}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Send
                </button>
              </div>
            </div>
          )}

          {action === "discount" && (
            <div className="mt-4 flex flex-col gap-3 p-4 border border-gray-300 rounded-lg bg-gray-50 ">
              <h3 className="text-sm font-medium text-gray-700 ">
                Select Categories and Set Discount
              </h3>

              <div className="flex flex-col gap-2 max-h-60 overflow-y-auto">
         {vendorCategories.map((cat) => (
  <div key={cat._id} className="flex items-center gap-3">
    <label className="inline-flex items-center gap-2 text-gray-700 ">
      <input
        type="checkbox"
        className="form-checkbox h-4 w-4 text-blue-600 rounded"
        checked={selectedCategories.includes(cat._id)}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedCategories((prev) => [...prev, cat._id]);
            setCategoryDiscounts((prev) => ({ ...prev, [cat._id]: 0 }));
          } else {
            setSelectedCategories((prev) => prev.filter((c) => c !== cat._id));
            setCategoryDiscounts((prev) => {
              const copy = { ...prev };
              delete copy[cat._id];
              return copy;
            });
          }
        }}
      />
      {/* Show vendor-assigned category name */}
      {cat.product_category_name}
    </label>

    {/* Discount input only when checked */}
    {selectedCategories.includes(cat._id) && (
      <input
        type="number"
        min="0"
        max="100"
        value={categoryDiscounts[cat._id] || ""}
        onChange={(e) =>
          setCategoryDiscounts((prev) => ({
            ...prev,
            [cat._id]: Number(e.target.value),
          }))
        }
        placeholder="% Discount"
        className="w-20 border rounded px-2 py-1 text-sm "
      />
    )}
  </div>
))}

              </div>

              <div className="flex justify-end gap-3 mt-3">
                <button
                  onClick={() => setAction(null)}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleSendDiscount(categoryDiscounts)}
                  className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Send
                </button>
              </div>
            </div>
          )}

{action === "unlock" && (
  <div className="mt-4 p-4 border border-gray-300 rounded-lg bg-gray-50">
    {unlockedLocation && (unlockedLocation.googleMapsLink || unlockedLocation.error) ? (
      <a
        href={unlockedLocation.googleMapsLink || unlockedLocation.error}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline break-words"
      >
        {unlockedLocation.googleMapsLink || unlockedLocation.error}
      </a>
    ) : (
      <span className="text-gray-500 text-center text-red-300">No location found</span>
    )}
  </div>
)}

        </div>
      </div>
    )}
  </div>
);


}
 